import { api } from '../../../shared/services/api/client';
import { createLogger } from '../../../shared/config/logger';
const logger = createLogger('general_settings');

export async function fetchGeneralSettings() {
    logger.info('Fetching general settings (frontend API call)');
    try {
        const response = await api.get('/settings/general');
        logger.info('Fetched general settings successfully', { data: response.data });
        return response;
    } catch (error) {
        logger.error('Error fetching general settings', { error });
        throw error;
    }
}

export async function updateGeneralSettings(payload) {
    logger.info('Updating general settings (frontend API call)', { payload });
    try {
        const response = await api.patch('/settings/general', payload);
        logger.info('Updated general settings successfully', { data: response.data });
        return response;
    } catch (error) {
        logger.error('Error updating general settings', { error });
        throw error;
    }
}

/** Resend the printable in-store customer signup QR code to the merchant account email. */
export async function resendMerchantSignupQrEmail() {
    logger.info('Resending merchant signup QR email');
    try {
        const response = await api.post('/merchant-signup-link/resend-email');
        logger.info('Resend merchant signup QR email OK', { data: response.data });
        return response;
    } catch (error) {
        logger.error('Resend merchant signup QR email failed', { error });
        throw error;
    }
}

/** Notify LoyalPass (loyalpassapp@gmail.com) that this merchant wants their account deleted. */
export async function postAccountDeletionRequest(body = {}) {
    logger.info('Posting account deletion request');
    try {
        const response = await api.post('/settings/account-deletion-request', body);
        logger.info('Account deletion request sent', { data: response.data });
        return response;
    } catch (error) {
        logger.error('Account deletion request failed', { error });
        throw error;
    }
}
